<template>
  <el-container class="doc" direction='vertical'>
    <div class="search-container">
      <div class="v-search-btn">
        <el-date-picker value-format="yyyy-MM-dd" class="v-date" v-model="valuedate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
        <el-input style="margin-left:16px;" v-model="valueid" clearable placeholder="请输入用户ID/手机号"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
      </div>
    </div>
    <div class="search-container">
      <!-- <div class="v-text">已兑换总数：<span>{{statisticsInfo.verify_all}}</span></div>
      <div class="v-text">本月兑换：<span>{{statisticsInfo.verify_month}}</span></div>
      <div class="v-text">今日兑换：<span>{{statisticsInfo.verify_today}}</span></div> -->
      <!-- <div class="v-text">已使用：<span>0</span></div>
      <div class="v-text">已作废：<span>13369</span></div> -->
      <div style="margin-right:30px;" class="certificationRecord">
        <el-radio-group v-model="radio" @change="changeRadio">
          <el-radio :label="4">全部</el-radio>
          <el-radio :label="0">未使用</el-radio>
          <el-radio :label="1">已使用</el-radio>
          <el-radio :label="3">已过期</el-radio>
          <el-radio :label="2">已作废</el-radio>
        </el-radio-group>
      </div>
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table :data="tableData" stripe highlight-current-row>
            <el-table-column align="center" width="250px" label="会员">
              <template slot-scope="scope">
                <div class="pay-member-photo">
                  <img :src="scope.row.member_wxheadurl" />
                </div>
                <div v-if="scope.row.member_name!==''" class="pay-member-name">{{ scope.row.member_name }}<br />ID：{{ scope.row.member_mid }}</div>
                <div v-else class="pay-member-name">{{ scope.row.member_wxname }}<br />ID：{{ scope.row.member_mid }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="兑换时间">
              <template slot-scope="scope">
                <span>{{ scope.row.starttime }}<br/> ~<br/> {{scope.row.endtime}} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="兑换码">
              <template slot-scope="scope">
                <span>{{ scope.row.cdkey }} </span>
              </template>
            </el-table-column>
            <el-table-column width="150px" align="center" label="获取方式">
              <template slot-scope="scope">
                <!-- <span>{{changeCouponType(scope.row.coupon_type )}} </span> -->
                <span v-if="scope.row.from==='1'">商家发放</span>
                <span v-if="scope.row.from==='0'">充值赠送</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="赠品名">
              <template slot-scope="scope">
                <span>{{ scope.row.coupon_name }} </span>
              </template>
            </el-table-column>
            <el-table-column width="100px" align="center" label="状态">
              <template slot-scope="scope">
                <span>{{changeCouponStatus(scope.row.status )}} </span>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="到期时间">
              <template slot-scope="scope">
                <span>{{ scope.row.endtime }} </span>
              </template>
            </el-table-column> -->
          </el-table>
        </el-scrollbar>
      </div>
      <el-pagination @current-change="currentChange" background v-if="total>20" :page-size="pageSize" layout="prev, pager, next" :current-page="page" :total="total">
      </el-pagination>
    </el-container>
  </el-container>
</template>
<script>
import { searchCouponList, couponStatistics } from '@/views/webpc/CashierDesk/CouponListApp/apis'
export default {
  data () {
    return {
      pageSize: 20,
      page: 1,
      total: 0,
      dialogVisible: false,
      radio: 4,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      valuedate: '',
      valueid: '',
      tableData: [],
      statisticsInfo: {}
    }
  },
  methods: {
    // 获取方式转换
    changeCouponType (status) {
      status = parseInt(status)
      switch (status) {
        case 0:
          return '充值赠送'
        default:
          return '其他'
      }
    },
    // 状态转换
    changeCouponStatus (status) {
      status = parseInt(status)
      switch (status) {
        case 0:
          return '未使用'
        case 1:
          return '已使用'
        case 2:
          return '已作废'
        case 3:
          return '已过期'
        default:
          return '其他'
      }
    },
    // 验证记录
    loadData () {
      this.isLoading = true
      this.tableData = []
      let data = new FormData()
      data.append('page', this.page)
      data.append('size', this.pageSize)
      data.append('keywords', this.valueid)
      if (this.radio < 4) {
        data.append('status', this.radio)
      }
      if (this.valuedate) {
        data.append('startdate', this.valuedate[0])
        data.append('enddate', this.valuedate[1])
      }
      searchCouponList(data)
        .then(result => {
          if (result) {
            this.isLoading = false
            this.tableData = result.data.list
            this.total = result.data.pager.records
          }
        }).catch(error => {
          if (error) {
            this.isLoading = false
          }
        })
    },
    // 分页
    currentChange (val) {
      this.page = val
      this.loadData()
    },
    clickSearch () {
      this.page = 1
      this.loadData()
    },
    // 验证统计
    getCouponStatistics () {
      couponStatistics()
        .then(result => {
          if (result) {
            this.statisticsInfo = result.data
          }
        })
    },
    // 分页
    changeRadio () {
      this.page = 1
      this.loadData()
    }
  },
  mounted () {
    this.loadData()
    // this.getCouponStatistics()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/CashierDesk/CouponListApp/CouponList.vue